export interface Testimonial {
  id: number;
  name: string;
  location: string;
  rating: number;
  date: string;
  comment: string;
  tour: string;
  avatar: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: "Sarah Lim Wei Ling",
    location: "Kuala Lumpur",
    rating: 5,
    date: "January 2026",
    comment: "Absolutely amazing experience! Arus Travel arranged everything perfectly for our Bali trip. The hotels were excellent, the guide was knowledgeable and friendly, and all the activities were well-organised. This was our third trip with Arus Travel and every time they exceed our expectations. Highly recommended to all my friends and family!",
    tour: "Enchanting Bali & Nusa Penida 6D5N",
    avatar: "https://public.readdy.ai/ai/img_res/6d40980d65f78f7746f603ba33000eb1.jpg",
  },
  {
    id: 2,
    name: "Ahmad Faizal bin Razak",
    location: "Petaling Jaya",
    rating: 5,
    date: "December 2025",
    comment: "The Japan Cherry Blossom tour was a dream come true. Our tour coordinator was very professional and attentive to our group's needs. The itinerary was perfectly paced — we never felt rushed. The hotel selections were top-notch and the local guide in Kyoto was incredibly informative. Will definitely book again!",
    tour: "Japan Cherry Blossom Escape 8D7N",
    avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20a%20Malaysian%20Malay%20man%20in%20his%2030s%20smiling%2C%20casual%20smart%20attire%2C%20clean%20background%2C%20natural%20lighting&width=80&height=80&seq=2002&orientation=squarish",
  },
  {
    id: 3,
    name: "Priya Rajasekaran",
    location: "Penang",
    rating: 5,
    date: "November 2025",
    comment: "We booked the Maldives Overwater Paradise package for our honeymoon and it was absolutely perfect! Every little detail was handled beautifully by the Arus Travel team. The overwater villa was stunning and the private beach dinner they arranged was so romantic. Cannot thank them enough!",
    tour: "Maldives Overwater Paradise 5D4N",
    avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20a%20young%20Malaysian%20Indian%20woman%20smiling%20happily%2C%20casual%20attire%2C%20clean%20light%20background%2C%20soft%20lighting%20photography&width=80&height=80&seq=2003&orientation=squarish",
  },
  {
    id: 4,
    name: "Chan Kah Wai",
    location: "Johor Bahru",
    rating: 5,
    date: "October 2025",
    comment: "Joined the Istanbul & Cappadocia tour and it was truly unforgettable. The hot air balloon ride at sunrise over Cappadocia was a once-in-a-lifetime moment. Our guide Mustafa was wonderful and very knowledgeable about the history. Arus Travel really knows how to deliver quality experiences at great value.",
    tour: "Istanbul & Cappadocia Wonder 9D8N",
    avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20a%20middle-aged%20Malaysian%20Chinese%20man%20smiling%2C%20smart%20casual%20attire%2C%20neutral%20background%2C%20natural%20lighting&width=80&height=80&seq=2004&orientation=squarish",
  },
  {
    id: 5,
    name: "Nurul Ain binti Hassan",
    location: "Shah Alam",
    rating: 4,
    date: "September 2025",
    comment: "Booked the Korea Cultural Discovery tour with my family of 5 and we had a fantastic time! The kids loved the Gyeongbokgung Palace experience and the Jeju day trip was beautiful. The tour manager was very helpful especially with our dietary requirements. One of the best family trips we have ever had.",
    tour: "Korea Cultural Discovery 7D6N",
    avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20a%20Malaysian%20Malay%20woman%20wearing%20hijab%20smiling%20warmly%2C%20casual%20attire%2C%20clean%20background%2C%20bright%20natural%20lighting&width=80&height=80&seq=2005&orientation=squarish",
  },
  {
    id: 6,
    name: "David Tan Boon Huat",
    location: "Subang Jaya",
    rating: 5,
    date: "August 2025",
    comment: "The Paris & Swiss Alps tour was beyond anything I expected. The Swiss Alps train ride through the mountains was breathtaking — photos simply cannot capture the beauty. Arus Travel's attention to detail is second to none. All transportation, accommodations, and guided tours were seamlessly arranged. Five stars without hesitation!",
    tour: "Romantic Paris & Swiss Alps 10D9N",
    avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20a%20Malaysian%20Chinese%20man%20in%20his%2040s%20smiling%20confidently%2C%20business%20casual%20shirt%2C%20clean%20neutral%20background%2C%20studio%20lighting&width=80&height=80&seq=2006&orientation=squarish",
  },
];
